<template>
  <vue-my-date-time-field
    :title="$t('pages.incomes.date_income')"
    v-bind="$attrs"
    v-on="$listeners"
  ></vue-my-date-time-field>
</template>

<script>
import { VueMyDateTimeField } from "../../../components/form";

export default {
  components: {
    VueMyDateTimeField
  }
};
</script>